import { useCallback } from 'react'

import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { Modal } from 'govwell-ui'

import Text from 'src/components/Typography/Text'
import { useDeleteAITrainingMaterialMutation } from 'src/fetch/aiTrainingMaterials'
import { UseDisclosureReturn } from 'src/hooks/use-disclosure'
import { RefetchFnType } from 'src/types'

interface Props {
  modalState: UseDisclosureReturn
  id: number
  refetch: RefetchFnType
}

const DeleteAITrainingMaterialModal = ({ modalState, id, refetch }: Props) => {
  const { isOpen, close } = modalState
  const { mutateAsync: deleteFn } = useDeleteAITrainingMaterialMutation()
  const handleDelete = useCallback(async () => {
    await deleteFn({ id })
    await refetch()
    close()
  }, [deleteFn, id, refetch, close])
  if (!isOpen) {
    return null
  }
  return (
    <Modal onClose={close}>
      <Modal.Header icon={faTrash}>Delete Document</Modal.Header>
      <Modal.Content>
        <Text>Are you sure you would like to delete this document?</Text>
      </Modal.Content>
      <Modal.Footer isDestructive confirmText="Delete document" onConfirm={handleDelete} />
    </Modal>
  )
}

export default DeleteAITrainingMaterialModal
